// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tips[data-v-736fcb65] { margin-bottom: 14px; padding: 10px 12px; background: #f8f8f9; color: #606266; font-size: 13px; line-height: 1.7;\n}\n.pdf-box[data-v-736fcb65] { height: 78vh;\n}\n.pdf-frame[data-v-736fcb65] { width: 100%; height: 100%; border: 0;\n}\n.pdf-error[data-v-736fcb65] { padding-top: 30vh; text-align: center; color: #909399;\n}\r\n", ""]);
// Exports
module.exports = exports;
